<div
	class="h-screen w-screen flex justify-center items-center top-0 absolute z-nuclear"
	(click)="$event.stopPropagation()"
>
	<div
		class="flex flex-col items-center bg-black h-screen w-screen absolute top-0 opacity-20"
	></div>
	<div class="flex flex-col items-center bg-white rounded-xl p-8 z-10">
		<h4 class="h4">{{ title$ | async }}</h4>
		<p class="p-sm mb-6">{{ subtitle$ | async }}</p>
		<app-icon [icon]="ICON.LOADING" class="text-3xl" [spin]="true"></app-icon>
	</div>
</div>
